if (!customElements.get('fj-bundle-offer')) customElements.define('fj-bundle-offer', class extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.root = document.getElementById(`MainProduct-${this.dataset.section}`);
    this.refresh = () => {
      const unavailable = this.root?.querySelector('product-form [name="add"]')?.disabled;
      const disabled = this.dataset.busy === 'true' || this.dataset.accessoryAvailable !== 'true' || unavailable !== false;
      if (this.button.disabled !== disabled) this.button.disabled = disabled;
    };
    this.observer = new MutationObserver(this.refresh);
    if (this.root) this.observer.observe(this.root, {subtree:true,childList:true,attributes:true,attributeFilter:['disabled']});
    this.refresh();
    this.action = async () => {
      const root = document.getElementById(`MainProduct-${this.dataset.section}`);
      const form = root?.querySelector('product-form form');
      const mainButton = form?.querySelector('[name="add"]');
      const id = form?.querySelector('[name="id"]')?.value;
      if (!id || mainButton?.disabled) return;
      const quantity = Number(root.querySelector('[name="quantity"]')?.value || 1);
      const error = this.querySelector('[data-fj-bundle-error]');
      this.dataset.busy = 'true';this.button.disabled = true;error.hidden = true;
      try {
        const response = await fetch(window.routes.cart_add_url + '.js', {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:Number(id),quantity},{id:Number(this.dataset.accessory),quantity}]})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message);
        window.location.assign(window.routes.cart_url);
      } catch (failure) {
        error.textContent = failure.message || window.cartStrings.error;
        error.hidden = false;delete this.dataset.busy;this.refresh();
      }
    };
    this.button.addEventListener('click', this.action);
  }
  disconnectedCallback() {this.button?.removeEventListener('click', this.action);this.observer?.disconnect();}
});
